export const DESKTOP_HEADER_ID = 'desktop-header';
